import { useMemo } from 'react';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import useUser from 'hooks/useUser';
import TraroElement from 'types/api/TraroElement';
import { canSubmitAnswers } from 'services/permissions';
import { useSelector } from 'store';
import { getQuestionSchema } from '../../QuestionComponents';

const useSchema = (traroElement: TraroElement) => {
  const user = useUser();
  const { t } = useTranslation();
  const rfpResponse = useSelector((state) => state.rfpResponse.data);

  return useMemo(() => {
    let shape: Record<string, yup.AnySchema> = {};

    if (canSubmitAnswers(user, rfpResponse)) {
      shape.questions = yup.object().shape(
        traroElement.kliparo_question_list.reduce((acc, question) => {
          acc[question.id] = yup.object().shape({
            value: getQuestionSchema(question, t),
          });
          return acc;
        }, {} as Record<number, yup.AnySchema>),
      );
    }

    if (user.isReviewer) {
      shape.score = yup
        .number()
        .min(0, t('errors.minNumber', { count: 0 }))
        .max(traroElement.max_score, t('errors.maxNumber', { count: traroElement.max_score }))
        .required(t('errors.minNumber', { count: 0 }));
    }

    return yup.object().shape(shape);
  }, [t, user, rfpResponse, traroElement.max_score, traroElement.kliparo_question_list]);
};

export default useSchema;
